import { render, staticRenderFns } from "./PercentBar.vue?vue&type=template&id=0148c53e&scoped=true"
import script from "./PercentBar.vue?vue&type=script&lang=js"
export * from "./PercentBar.vue?vue&type=script&lang=js"
import style0 from "./PercentBar.vue?vue&type=style&index=0&id=0148c53e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148c53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0148c53e')) {
      api.createRecord('0148c53e', component.options)
    } else {
      api.reload('0148c53e', component.options)
    }
    module.hot.accept("./PercentBar.vue?vue&type=template&id=0148c53e&scoped=true", function () {
      api.rerender('0148c53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/components/PercentBar.vue"
export default component.exports